import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';
import type { ContactUsMessageRequest, ContactUsRecipient } from '~/types';
import type { NitroFetchOptions } from 'nitropack';

export function useContact() {
    const apiBasePath = `/v1/contact-us`;
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();

    async function getRecipients(): Promise<ContactUsRecipient | Error> {
        const url = `${apiBasePath}/`;

        try {
            const response = await $_fetch<ContactUsRecipient>(url);
            return response;
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    async function sendMessage(messageObj: ContactUsMessageRequest): Promise<number | Error> {
        const url = `${apiBasePath}/`;
        const config: NitroFetchOptions<string> = {
            method: 'POST',
            body: messageObj
        };

        try {
            const response = await $_fetch.raw<void>(url, config);
            return response.status;
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    return {
        getRecipients,
        sendMessage
    };
}
